import { schema } from 'normalizr';

export const scraperLogSchema = new schema.Entity('scraperLogs');
export const scrapersLogsSchema = new schema.Array(scraperLogSchema);
